/**
 * 定期主動更新 access token
 *
 * 客戶 2026-09-09 說明其 JWT 機制：
 *   access token  15 分鐘過期
 *   refresh token 7 天過期
 *   → 「要請前端定期透過 /v1/auth/refresh 取得新的 access token」
 *
 * 原本僅在收到 401 後被動 refresh，使用者會先看到一次失敗；
 * 改為定期主動更新，讓 token 在過期前就換新。
 *
 * ⚠️ refresh 端點的 refreshToken 必須放在 Authorization header（規格 requestBody 為 null）。
 */
import axios from "axios";

const PRIEMS_API = import.meta.env.VITE_PRIEMS_API_URL;

// access token 15 分鐘到期，提前於第 12 分鐘更新，留 3 分鐘緩衝
const REFRESH_INTERVAL_MS = 12 * 60 * 1000;

let timer = null;

export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) return false;

  try {
    const { data } = await axios.post(`${PRIEMS_API}/v1/auth/refresh`, null, {
      headers: { Authorization: `Bearer ${refreshToken}` },
    });
    if (data?.accessToken) {
      localStorage.setItem("accessToken", data.accessToken);
      // 若 API 回傳新的 refreshToken 一併更新（支援多裝置共存）
      if (data.refreshToken) {
        localStorage.setItem("refreshToken", data.refreshToken);
      }
      return true;
    }
  } catch {
    // 失敗不在此處登出：401 攔截器仍會處理，避免背景失敗直接踢人
  }
  return false;
};

/** 啟動定期更新（登入後呼叫） */
export const startTokenRefresh = () => {
  stopTokenRefresh();
  timer = setInterval(refreshAccessToken, REFRESH_INTERVAL_MS);
};

/** 停止定期更新（登出時呼叫） */
export const stopTokenRefresh = () => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
};
